import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { API_STATUS } from '../../constants';
import { KpiMetricType } from '../../types/kpiMetric';
import { fetchKpiMetrics } from './kpiMetrics.thunks';
import { kpiMetricsStoreKey } from './kpiMetrics.const';

export interface KpiMetricsState {
  apiStatus: API_STATUS;
  kpiMetricsList: KpiMetricType[];
}

const initialState: KpiMetricsState = {
  kpiMetricsList: [],
  apiStatus: API_STATUS.IDLE,
};

export const kpiMetricsSlice = createSlice({
  name: kpiMetricsStoreKey,
  initialState,
  reducers: {
    clearKpiMetrics: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchKpiMetrics.pending, (state) => {
        state.apiStatus = API_STATUS.LOADING;
      })
      .addCase(
        fetchKpiMetrics.fulfilled,
        (state, action: PayloadAction<KpiMetricType[]>) => {
          state.apiStatus = API_STATUS.IDLE;
          state.kpiMetricsList = action.payload;
        },
      )
      .addCase(fetchKpiMetrics.rejected, (state) => {
        state.apiStatus = API_STATUS.FAILED;
      });
  },
});

export const { clearKpiMetrics } = kpiMetricsSlice.actions;
